<script lang="ts">
  import { range, rangeInclude } from '$lib/utils/array';
  import { idToSkills } from './skills';
  import { maxSkillLevel, skillSlots } from './consts';

  export let characterId: number;
  export let skillIdSeries: (number | null)[];
  export let skillSlotSeries: string[] | undefined = undefined;

  $: characterSkills = [...$idToSkills.values()].filter(
    (skill) => skill.characterId === characterId,
  );
  $: series =
    skillSlotSeries ??
    skillIdSeries
      ?.map(
        (skillId) =>
          characterSkills.find((skill) => skill.id === Math.floor((skillId ?? 0) / 100) * 100)
            ?.slot ?? '',
      )
      .filter((value) => value !== '') ??
    [];
</script>

<table class="skill-tree">
  <tr>
    <td />
    {#each rangeInclude(1, series.length) as level}
      <td>{level}</td>
    {/each}
  </tr>
  {#each skillSlots as skillSlot}
    <tr>
      <td>
        {skillSlot}
      </td>
      {#each range(0, series.length) as skillIndex}
        {@const isSkillOfThisLevel = skillSlot === series[skillIndex]}
        {@const isMaster =
          isSkillOfThisLevel &&
          series.slice(0, skillIndex + 1).filter((slot) => slot === series[skillIndex]).length ===
            maxSkillLevel[skillSlot]}
        <td class="skill-item" data-has={isSkillOfThisLevel} data-master={isMaster}>
          {#if isSkillOfThisLevel}
            {skillSlot}
          {/if}
        </td>
      {/each}
    </tr>
  {/each}
</table>

<style lang="postcss">
  @import '$lib/styles/breakpoints.css';

  .skill-tree {
    font-size: var(--size-4);

    @media (--sm) {
      font-size: var(--size-5);
    }
  }

  td {
    width: 2rem;
    height: 2rem;
    text-align: center;
  }

  .skill-item {
    background-color: var(--mauve-a3);
    border-radius: var(--radius-1);

    &[data-has='true'] {
      background-color: var(--text);
      color: var(--background);
    }
    &[data-master='true'] {
      background-color: var(--brand);
      color: white;
    }
  }
</style>
